export default "__VITE_ASSET__lYv5_D6x__"